import BillList from '@/views/mobile/BillList/index'

// 定义路由路径数列表
export default [{
  path: '/billList',
  name: '账单列表',
  component: BillList
}]



// WEBPACK FOOTER //
// ./src/views/mobile/BillList/routers/index.js